import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import styled from 'styled-components';
import { theme, media } from 'styles';
import { Button } from 'components/shared';
import { getCartCurrency } from 'ducks/cart';
import { ClockFreeSvg, ClockThirtySvg, ClockSixtySvg } from 'images';

const Wrapper = styled.div``;
const Tiles = styled.div`
  display: flex;
  justify-content: space-between;
  flex-direction: column;
  ${media.tablet`
    flex-direction: row;
  `};
`;
const TileWrapper = styled.div`
  margin-bottom: ${theme.sp.s};
  width: 100%;

  ${media.tablet`
    width: calc((100% - ${parseInt(theme.sp.xl, 10) * 2}px) / 3);
  `};

  &:nth-child(3n + 3) {
    margin-right: 0;
  }
`;
const Tile = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  border-radius: 6px;
  border: ${props =>
    props.selected
      ? `2px solid ${theme.colors.blue}`
      : '2px solid transparent'};
  box-shadow: ${theme.boxShadow.small};
  background-color: ${theme.colors.white};
  width: 100%;
  padding: 10px;
  ${media.tablet`
    text-align: center;
    flex-direction: column;
    padding: 20px;
    border: ${props =>
      props.selected
        ? `6px solid ${theme.colors.blue}`
        : '6px solid transparent'};
  `};
  font-size: 16px;
  line-height: 20px;
  color: ${theme.colors.navy};
  text-decoration: none;
`;
const TileContent = styled.div``;
const Image = styled.div`
  background-position: center center;
  background-image: url('${props => props.src}');
  background-repeat: no-repeat;
  width: 100%;
  height: 200px;
  display:none;
  ${media.tablet`
    display: inherit;
  `};

`;

const Name = styled.div`
  line-height: 20px;
  color: ${theme.colors.navy};
  ${media.tablet`
    height: 60px;
  `};
`;

const Price = styled.div`
  ${media.tablet`
    padding-bottom: 10px;
  `};
`;

const Cta = styled(Button)`
  background-color: ${theme.colors.blue};
`;

const getImageForSession = session => {
  const { name } = session;
  if (name.match(/30/)) {
    return ClockThirtySvg;
  } else if (name.match(/60/)) {
    return ClockSixtySvg;
  }
  return ClockFreeSvg;
};

const getPadding = session => {
  const { lengthInMinutes } = session;
  if (lengthInMinutes === 20) {
    return 'free';
  }
  return 'paid';
};

function SessionPicker({
  sessions,
  selectedSessionId,
  onSetMarketerSessionId,
  currency,
}) {
  return (
    <Wrapper>
      <Tiles>
        {sessions &&
          sessions.map(session => (
            <TileWrapper key={session.id}>
              <Tile selected={session.id === selectedSessionId}>
                <TileContent>
                  <Image
                    src={getImageForSession(session)}
                    padding={getPadding(session)}
                  />
                  <Name>{session.name}</Name>
                  <Price>
                    {session.prices[currency].price === 0
                      ? 'FREE'
                      : `${session.prices[currency].formattedPrice}`}
                  </Price>
                </TileContent>
                <TileContent>
                  <Cta onClick={() => onSetMarketerSessionId(session.id)}>
                    Select
                  </Cta>
                </TileContent>
              </Tile>
            </TileWrapper>
          ))}
      </Tiles>
    </Wrapper>
  );
}

SessionPicker.propTypes = {
  sessions: PropTypes.arrayOf({}).isRequired,
  selectedSessionId: PropTypes.number.isRequired,
  onSetMarketerSessionId: PropTypes.func.isRequired,
  currency: PropTypes.func.isRequired,
};

const mapStateToProps = state => ({
  currency: getCartCurrency(state),
});

export default connect(mapStateToProps)(SessionPicker);



// WEBPACK FOOTER //
// ./src/components/BookMarketerPage/components/SessionPicker/SessionPicker.jsx